import React from 'react';
import { Award, Users, Target, TrendingUp } from 'lucide-react';

export const AboutSection = () => {
  return (
    <section id="about" className="py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            About FillTech Technologies and Solutions
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Your Trusted Partner in Printer Consumables and Solutions
          </p>
        </div>

        {/* Content Grid */}
        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          {/* Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://customer-assets.emergentagent.com/job_printer-supplies-1/artifacts/c3uf2xbs_Store%20photo-1.jpeg"
                alt="FillTech Technologies Showroom - Wide range of printer consumables"
                className="w-full h-[400px] object-cover"
              />
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-blue-100 rounded-2xl -z-10"></div>
          </div>

          {/* Text Content */}
          <div className="space-y-6">
            <p className="text-gray-700 text-lg leading-relaxed">
              FillTech Technologies and Solutions is one of the largest and most complete showrooms in Central Kerala specializing in computer printer consumables, printers, printer accessories, and printer spare parts. With over <span className="font-bold text-blue-900">15 years of experience</span> in the industry, we have built a reputation for excellence and reliability.
            </p>
            <p className="text-gray-700 text-lg leading-relaxed">
              With a strong commitment to quality, affordability, and customer satisfaction, FillTech has become a trusted destination for businesses, dealers, offices, and individual customers seeking reliable printing solutions.
            </p>
            <p className="text-gray-700 text-lg leading-relaxed">
              We offer a wide range of products including toner cartridges, printer inks, toner cartridge spares, toner refilling materials, and genuine OEM printer consumables — all available at competitive wholesale prices.
            </p>
          </div>
        </div>

        {/* Second Row - Image on Right */}
        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          {/* Text Content */}
          <div className="space-y-6 order-2 lg:order-1">
            <h3 className="text-2xl font-bold text-gray-900">Our Commitment</h3>
            <p className="text-gray-700 text-lg leading-relaxed">
              We are proud distributors of Image King Toner Powder, Compatible toner cartridges, and original inks and cartridges from Epson, Canon, HP, Brother, and TVS Electronics.
            </p>
            <p className="text-gray-700 text-lg leading-relaxed">
              At FillTech, we believe that quality products should always be backed by excellent customer service. Our experienced team provides dependable after-sales support and helps customers find the right printing solutions for their needs.
            </p>
            <p className="text-gray-700 text-lg leading-relaxed font-semibold text-blue-900">
              Our mission is to fulfill every customer's needs, preferences, and expectations by delivering high-quality products at reasonable prices that others cannot match.
            </p>
          </div>

          {/* Image */}
          <div className="relative order-1 lg:order-2">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://customer-assets.emergentagent.com/job_printer-supplies-1/artifacts/dm4hj44o_Store%20Photo-2.jpeg"
                alt="FillTech Inventory - Image King Toner Powder Stock"
                className="w-full h-[400px] object-cover"
              />
            </div>
            {/* Decorative element */}
            <div className="absolute -top-6 -left-6 w-48 h-48 bg-cyan-100 rounded-2xl -z-10"></div>
          </div>
        </div>

        {/* Value Props Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="bg-blue-50 p-6 rounded-xl border border-blue-100 hover:shadow-lg transition-shadow duration-200">
            <Award className="text-blue-900 mb-4" size={40} />
            <h4 className="text-lg font-bold text-gray-900 mb-2">Quality Assured</h4>
            <p className="text-gray-600">100% genuine OEM products from trusted brands</p>
          </div>
          <div className="bg-cyan-50 p-6 rounded-xl border border-cyan-100 hover:shadow-lg transition-shadow duration-200">
            <Users className="text-cyan-700 mb-4" size={40} />
            <h4 className="text-lg font-bold text-gray-900 mb-2">Customer First</h4>
            <p className="text-gray-600">Dedicated support and personalized service</p>
          </div>
          <div className="bg-blue-50 p-6 rounded-xl border border-blue-100 hover:shadow-lg transition-shadow duration-200">
            <Target className="text-blue-900 mb-4" size={40} />
            <h4 className="text-lg font-bold text-gray-900 mb-2">Best Prices</h4>
            <p className="text-gray-600">Competitive wholesale rates in Kerala</p>
          </div>
          <div className="bg-cyan-50 p-6 rounded-xl border border-cyan-100 hover:shadow-lg transition-shadow duration-200">
            <TrendingUp className="text-cyan-700 mb-4" size={40} />
            <h4 className="text-lg font-bold text-gray-900 mb-2">Trusted Partner</h4>
            <p className="text-gray-600">Long-term relationships with satisfied clients</p>
          </div>
        </div>
      </div>
    </section>
  );
};
